"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.transformTheme = exports.createMediaQueries = exports.sortBreakpoints = void 0;

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          ", "\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      @media (min-width: ", "em) {\n        ", ";\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var sortBreakpoints = function sortBreakpoints(breakpoints) {
  return Object.keys(breakpoints).sort(function (a, b) {
    return breakpoints[a] - breakpoints[b];
  });
};

exports.sortBreakpoints = sortBreakpoints;

var createMediaQueries = function createMediaQueries(_ref) {
  var breakpoints = _ref.breakpoints,
      rootSize = _ref.rootSize,
      css = _ref.css;
  return Object.keys(breakpoints).reduce(function (accumulator, label) {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    var emSize = breakpoints[label] / rootSize;

    accumulator[label] = function () {
      return css(_templateObject(), emSize, css.apply(void 0, arguments));
    };

    return accumulator;
  }, {});
};

exports.createMediaQueries = createMediaQueries;

var transformTheme = function transformTheme(_ref2) {
  var theme = _ref2.theme,
      breakpoints = _ref2.breakpoints;
  var result = {};
  breakpoints.forEach(function (item) {
    result[item] = {};
  });
  Object.keys(theme).forEach(function (item) {
    if (Array.isArray(theme[item])) {
      theme[item].forEach(function (child, i) {
        result[breakpoints[i]][item] = child;
      });
    } else if (_typeof(theme[item]) === 'object') {
      var subObject = theme[item];
      Object.keys(subObject).forEach(function (child) {
        result[child][item] = subObject[child];
      });
    } else {
      result[breakpoints[0]][item] = theme[item];
    }
  });
  return result;
};

exports.transformTheme = transformTheme;

var makeItResponsive = function makeItResponsive(_ref3) {
  var css = _ref3.css,
      styles = _ref3.styles;
  return function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        theme = _ref4.theme;

    var breakpoints = theme.breakpoints,
        rootSize = theme.rootSize,
        t = _objectWithoutProperties(theme, ["breakpoints", "rootSize"]);

    var sortedBreakpoints = sortBreakpoints(breakpoints);
    var media = createMediaQueries({
      breakpoints: breakpoints,
      rootSize: rootSize,
      css: css
    });
    var transformedTheme = transformTheme({
      theme: t,
      breakpoints: sortedBreakpoints
    });
    return sortedBreakpoints.map(function (item, i) {
      var hasBreakpointProperties = Object.keys(transformedTheme[item]).length > 0;

      if (hasBreakpointProperties) {
        var result = styles({
          theme: transformedTheme[item],
          css: css,
          rootSize: rootSize
        });

        if (i === 0) {
          return css(_templateObject2(), result);
        }

        return media[item](_templateObject3(), result);
      }
    });
  };
};

var _default = makeItResponsive;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/coolgrid/dist/utils/media.js
// module id = 26
// module chunks = 0